<div class="bucket-head">
  <div class="bucket-head__expand-icon-wrapper" (click)="toggleBucketExpanded()">
    @if (hasBucketAnyChildren()) {
      <mat-icon class="bucket-head__expand-icon material-icons-outlined">
        {{ isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
    } @else {
      <mat-icon class="bucket-head__expand-icon bucket-head__expand-icon--leaf" svgIcon="indentation" />
    }
  </div>

  <span class="bucket-head__label truncate" (click)="onBucketClick()" [title]="bucketTooltip()">
    {{ bucket().label }}
  </span>

  <span class="bucket-head__count">
    {{ bucket().count | number }}
  </span>
</div>

@if (bucketChildrenTemplate && hasBucketAnyChildren() && isExpanded()) {
  <div class="bucket-children">
    <ng-template [ngTemplateOutlet]="bucketChildrenTemplate" />
  </div>
}
